// Uses window.localStorage API for storing and retrieving data

const get = keys => {
  return new Promise((resolve, reject) => {
    if (typeof keys === 'string' || keys instanceof String) {
      const rawValue = localStorage.getItem(keys)
      const value = rawValue ? JSON.parse(rawValue) : rawValue
      if (value == null) {
        resolve({})
      } else {
        resolve({ [keys]: value })
      }
    } else if (Array.isArray(keys) && keys.every(i => typeof i === 'string')) {
      const values = {}
      keys.forEach(key => {
        const rawValue = localStorage.getItem(key)
        const storageValue = rawValue ? JSON.parse(rawValue) : rawValue
        if (storageValue !== null) {
          values[key] = storageValue
        }
      })
      resolve(values)
    } else {
      reject({ error: 'Keys must be a string or array of strings' })
    }
  })
}

const set = items => {
  return new Promise((resolve, reject) => {
    if (typeof items === 'object' && items !== null && !Array.isArray(items)) {
      const keys = Object.keys(items)
      keys.forEach(key => {
        localStorage.setItem(key, JSON.stringify(items[key]))
      })
      resolve()
    } else {
      reject({ error: 'Items must be an object' })
    }
  })
}

const remove = keys => {
  return new Promise((resolve, reject) => {
    if (typeof keys === 'string' || keys instanceof String) {
      localStorage.removeItem(keys)
      resolve()
    } else if (Array.isArray(keys) && keys.every(i => typeof i === 'string')) {
      keys.forEach(key => {
        localStorage.removeItem(key)
      })
      resolve()
    } else {
      reject('Keys must be a string or array of strings')
    }
  })
}

// Used for debugging
const displayName = 'localStorageAdapter'

const localStorageAdapter = {
  get,
  set,
  remove,
  displayName
}

export default localStorageAdapter
